import http from '@/utils/request'

export async function listTag(param, callId = null, callArgs = {}) {
  let url = `/util/list_tag`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function createTag(data, callId = null, callArgs = {}) {
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: '/util/create_tag',
    method: 'post',
    data
  })
}

export async function updateTag(data, callId = null, callArgs = {}) {
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: `/util/update_tag/${data.id}`,
    method: 'post',
    data
  })
}

export async function delTag(data, callId = null, callArgs = {}) {
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: `/util/del_tag/${data.id}`,
    method: 'post',
    data
  })
}

export async function listTagObj(param, callId = null, callArgs = {}) {
  let url = `/util/list_tag_obj`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

// 参数：
// {
//   "tag_id": 1160827977498886144,
//   "obj_id": 1143634047980273664
// }
export async function createTagObj(data, callId = null, callArgs = {}) {
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: '/util/create_tag_obj',
    method: 'post',
    data
  })
}

export async function delTagObj(data, callId = null, callArgs = {}) {
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: `/util/del_tag_obj/${data.id}`,
    method: 'post',
    data
  })
}

export async function sendVcode(param, callId = null, callArgs = {}) {
  let url = `/util/send_vcode`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'POST',
    data: param.data
  })
}
